import { Box, Typography, Container } from '@mui/material';
import Wallpaper from '../assets/clover.jpg';

const Business = () => {
  return (
    <Container
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // スマホでは縦並び、PCでは横並び
    height: "100vh",
    width: "100%",
  }}
>
  <Box
    sx={{
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center", // スマホではこの行は削除
      alignItems: "center",
      textAlign: "center",
      position: "relative", // 背景オーバーレイ用
      backgroundImage: `url(${Wallpaper})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      padding: 2,
      marginTop: { xs: "80px", sm: "80px", md: 0 }, // ヘッダーに食い込まないように上部に余白
    }}
  >
    {/* オーバーレイの白い背景 */}
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.3)", // 白の透明度
        backdropFilter: "blur(5px)", // 背景のぼかし
        zIndex: 1, // コンテンツより下に配置
      }}
    />

    {/* コンテンツ */}
    <Box
      sx={{
        position: "relative", // オーバーレイの上に配置
        zIndex: 2,
        color: "white",
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          fontSize: "40px",
          fontWeight: "bold",
          fontFamily: "'Noto Serif JP', serif",
        }}
      >
        Business
      </Typography>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold',fontFamily: "'Noto Serif JP', serif"}}>
        事業説明
      </Typography>
    </Box>
  </Box>

  {/* 右側のコンテンツ */}
  <Box
    sx={{
      flex: 2, // 右側の幅
      display: "flex",
      flexDirection: "column",
      justifyContent: {xs: 'flex-start', md: "center" },
      textAlign: { xs: "left", md: "left" }, // スマホでは左揃え、PCでも左揃え
      padding: 4, // 余白
      order: { xs: 1, md: 1 }, // スマホではテキストが下、PCでは右に配置
    }}
  >
    <Typography
      variant="body1"
      gutterBottom
      sx={{
        fontWeight: "bold",
        fontSize: { xs: "16px", md: "25px", fontFamily: "'Noto Serif JP', serif" }, // スマホ: 14px, PC: 20px
      }}
    >
      ■ ITソリューション事業
    </Typography>
    <Typography
      variant="body1"
      gutterBottom
      sx={{
        fontSize: { xs: "14px", md: "20px", fontFamily: "'Noto Serif JP', serif" }, // スマホ: 12px, PC: 16px
        textAlign: "left", // 左揃え
        marginLeft: "15px",
        marginBottom: '20px'
      }}
    >
      Java,Rubyが得意な開発系エンジニアをアサインし、
      <br />
      お客様のシステム開発をサポートします。
      <br />
      また豊富な実績のあるパートナー企業のご協力により
      <br />
      適切なエンジニアを現場にアサインします。
      <br />
    </Typography>
    <Typography
      variant="body1"
      gutterBottom
      sx={{
        fontWeight: "bold",
        fontSize: { xs: "16px", md: "25px", fontFamily: "'Noto Serif JP', serif" }, // スマホ: 14px, PC: 20px
        marginBottom: '20px'
      }}
    >
      ■ e-sports事業
    </Typography>
    <Typography
      variant="body1"
      gutterBottom
      sx={{
        fontWeight: "bold",
        fontSize: { xs: "16px", md: "25px", fontFamily: "'Noto Serif JP', serif" }, // スマホ: 14px, PC: 20px
      }}
    >
      ■ 動画配信事業
    </Typography>
    <Typography
      variant="body1"
      gutterBottom
      sx={{
        fontSize: { xs: "14px", md: "20px", fontFamily: "'Noto Serif JP', serif" }, // スマホ: 12px, PC: 16px
        textAlign: "left", // 左揃え
        marginLeft: "15px",
      }}
    >
      企業認知向上のため様々な外部活動に挑戦しています
    </Typography>
  </Box>
</Container>

  );
};

export default Business;  
